/**
 * Split table checkout (tables without per-person ordering).
 * The whole table is shown on top and the selected person below; tapping a line
 * moves one unit between them, press and hold moves the whole line.
 * Assignments are saved immediately, so the cart's own products stay empty while split is active.
 */

let initTableSplitGestures = function () {};

/**
 * Re-open split mode on a table after one person has paid
 * @param {number|string} sessionId
 */
function returnToTableSplitCheckout(sessionId) {
  delete locationCart.table_split_return_session_id;
  locationCart.table_split_view = 'split';
  return setClassicLocationCart({
    ...locationCart,
    products: [],
    number_of_products: 0,
    checkout_type: 'normal',
    table_session_id: sessionId,
    table_guest_id: null,
  });
}

$(function () {
  let tableSplitAjaxLock = false;

  function showTableSplitError(response) {
    if (response.responseJSON?.redirect_url) {
      document.location.href = response.responseJSON.redirect_url;
      return;
    }
    showToast({
      type: 'error',
      message: response.responseJSON?.message || 'Noe gikk galt',
      position: 'bottom-right',
      duration: 2000,
    });
  }

  function renderTableSplit(view, guestId) {
    locationCart.table_split_view = view;
    return setClassicLocationCart({
      ...locationCart,
      products: [],
      number_of_products: 0,
      checkout_type: 'normal',
      table_guest_id: guestId || null,
    });
  }

  function hideTableSplitGuestModal(callback) {
    const $modal = $('#table-split-guest-modal');
    if (!$modal.length || !$modal.hasClass('show')) {
      callback();
      return;
    }
    $modal.one('hidden.bs.modal', callback).modal('hide');
  }

  // Load what is left on the table (or one person's products) into the normal checkout
  function loadTableCartData(sessionId, guestId = null) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/sessions/get-cart-data',
      data: { sessionId, guestId },
    }).done(function (response) {
      const cartProducts = response.data?.cartProducts || [];
      setClassicLocationCart({
        ...locationCart,
        products: cartProducts,
        number_of_products: cartProducts.length,
        checkout_type: 'normal',
        table_session_id: sessionId,
        table_guest_id: guestId,
        share_amount: 0,
        isSessionLastPurchase: response.data?.isSessionLastPurchase || false,
      });
    });
  }

  function moveTableSplitUnit(url, data) {
    if (tableSplitAjaxLock) return;
    tableSplitAjaxLock = true;

    $.ajax({
      type: 'POST',
      url,
      data: {
        ...data,
        sessionId: locationCart.table_session_id,
        guestId: locationCart.table_guest_id,
      },
    })
      .done(function () {
        getClassicCartModal().always(function () {
          tableSplitAjaxLock = false;
        });
      })
      .fail(function (response) {
        tableSplitAjaxLock = false;
        showTableSplitError(response);
        getClassicCartModal();
      });
  }

  $(document).on('click', '.js-table-split-toggle', function () {
    const sessionId = $(this).attr('data-session-id');

    if (locationCart.table_split_view === 'split') {
      delete locationCart.table_split_view;
      locationCart.table_order = 1;
      $('#table-split-guest-modal').remove();
      loadTableCartData(sessionId).fail(showTableSplitError);
      return;
    }

    if (
      !locationCart.table_split_view &&
      locationCart.products.some((product) => !product.session_product_id)
    ) {
      showToast({
        type: 'error',
        message: 'Lagre nye varer på bordet før du splitter.',
        position: 'bottom-right',
        duration: 3000,
      });
      return;
    }

    locationCart.table_session_id = sessionId;
    renderTableSplit('split', null);
  });

  $(document).on('click', '.js-table-split-exit', function () {
    function exitTableCheckout() {
      delete locationCart.table_split_return_session_id;
      hideTableSplitGuestModal(function () {
        emptyAllCart();
      });
    }

    // Split view keeps the cart's own products empty, so this only hits the table order view
    const hasUnsentProducts = (locationCart.products || []).some(
      (product) => !product.session_product_id
    );
    if (!hasUnsentProducts) {
      exitTableCheckout();
      return;
    }

    customConfirm(
      'Det er produkter som ikke er sendt til bordet. Vil du avslutte uten å sende bestillingen?',
      'warning'
    ).then(function (confirmed) {
      if (confirmed) exitTableCheckout();
    });
  });

  function moveTableSplitLine($line, all) {
    if ($line.hasClass('js-split-table-product')) {
      moveTableSplitUnit('/api/v1/private/sessions/split-assign', {
        sessionProductId: $line.attr('data-session-product-id'),
        all,
      });
    } else {
      moveTableSplitUnit('/api/v1/private/sessions/split-unassign', {
        productAssignmentId: $line.attr('data-product-assignment-id'),
        all,
      });
    }
  }

  // Tap moves one; the hold plugin swallows the click that ends a completed hold
  $(document).on(
    'click',
    '.js-split-table-product, .js-split-person-product',
    function () {
      moveTableSplitLine($(this), 0);
    }
  );

  // Called after every split checkout render (the lines are replaced each time)
  initTableSplitGestures = function () {
    $('.js-split-table-product, .js-split-person-product').holdToConfirm({
      svgSelector: '.table-ring-svg',
      totalDuration: 1000,
      holdDelay: 250,
      onComplete: function ($wrap) {
        moveTableSplitLine($wrap, 1);
      },
    });
  };

  $(document).on('click', '.js-split-pay', function () {
    const sessionId = $(this).attr('data-session-id');
    const guestId = $(this).attr('data-guest-id');
    if (!guestId || tableSplitAjaxLock) return;
    tableSplitAjaxLock = true;

    delete locationCart.table_split_view;
    delete locationCart.table_order;
    $('#table-split-guest-modal').remove();
    locationCart.table_split_return_session_id = sessionId;

    loadTableCartData(sessionId, guestId)
      .fail(function (response) {
        delete locationCart.table_split_return_session_id;
        showTableSplitError(response);
        renderTableSplit('split', guestId);
      })
      .always(function () {
        tableSplitAjaxLock = false;
      });
  });

  $(document).on('click', '.js-split-select-person', function () {
    $('#table-split-guest-modal').modal('show');
  });

  $(document).on('click', '.js-split-next-person', function () {
    const nextGuestId = $(this).attr('data-next-guest-id');
    if (nextGuestId) {
      renderTableSplit('split', nextGuestId);
      return;
    }

    addTableSplitGuest($(this).attr('data-session-id'));
  });

  $(document).on('click', '.js-split-whole-table', function () {
    hideTableSplitGuestModal(function () {
      renderTableSplit('whole', null);
    });
  });

  $(document).on('click', '.js-split-select-guest', function () {
    const guestId = $(this).attr('data-guest-id');
    hideTableSplitGuestModal(function () {
      renderTableSplit('split', guestId);
    });
  });

  $(document).on('click', '.js-split-add-guest', function () {
    const sessionId = $(this).attr('data-session-id');
    hideTableSplitGuestModal(function () {
      addTableSplitGuest(sessionId);
    });
  });

  $(document).on('click', '.js-split-add-named-guest', function () {
    const sessionId = $(this).attr('data-session-id');
    const guestName = $('#tableSplitGuestNameInput').val().trim();
    if (!guestName) return;
    hideTableSplitGuestModal(function () {
      addTableSplitGuest(sessionId, guestName);
    });
  });

  function addTableSplitGuest(sessionId, guestName = null) {
    if (tableSplitAjaxLock) return;
    tableSplitAjaxLock = true;

    $.ajax({
      type: 'POST',
      url: '/api/v1/private/table-guests/add',
      data: guestName
        ? { session_id: sessionId, guest_name: guestName }
        : { session_id: sessionId },
    })
      .done(function (response) {
        const newGuestId =
          response.data?.guestId || response.data?.addedGuestId;
        renderTableSplit('split', newGuestId);
      })
      .fail(showTableSplitError)
      .always(function () {
        tableSplitAjaxLock = false;
      });
  }
});
